import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface ConsultationButtonProps {
  className?: string;
  size?: "default" | "sm" | "lg" | "icon" | null | undefined;
  fullWidth?: boolean;
}

const ConsultationButton = ({ className, size = "default", fullWidth = false }: ConsultationButtonProps) => {
  return (
    <Button
      asChild
      size={size}
      className={cn(
        "rounded-full btn-gold border-0 font-semibold",
        fullWidth && "w-full",
        className
      )}
    >
      <Link to="/contact">Get Free Audit</Link>
    </Button>
  );
};

export default ConsultationButton;
